import { Trace } from "../../../telemetry/Trace";
import { dashboard } from "../../../telemetry/TraceLogging";
import { tryGetHostApi } from "../../externalApi/externalApi";
import { WidgetGeolocation } from "./WidgetGeolocation";
export class WidgetGeolocationApi {
    constructor() {
        this._geoLocation = undefined;
        this._geoLocationApi = null;
        this._eventListeners = new Array();
    }
    async initialize() {
        if (!this._geoLocationApi) {
            this._geoLocationApi = (await tryGetHostApi("Geolocation", 1, 1));
            if (!this._geoLocationApi) {
                // Api not available when running outside the host
                Trace.logEvent(dashboard, "GeolocationAPIUnavailable", 1 /* information */);
            }
            else {
                await this._geoLocationApi.addEventListener("positionchanged", async () => {
                    // Update the cached value for when the listeners will fetch it
                    await this.getLocationInternalAsync(true);
                    await this.fireEvent("positionChanged");
                });
            }
        }
    }
    async getLocation() {
        // Return the latest cached location
        return await this.getLocationInternalAsync(false);
    }
    addEventListener(listener) {
        this._eventListeners.push(listener);
    }
    removeEventListener(listener) {
        let index = this._eventListeners.indexOf(listener);
        if (index > -1) {
            this._eventListeners.splice(index, 1);
        }
    }
    async fireEvent(eventName) {
        for (let index = 0; index < this._eventListeners.length; index++) {
            if (this._eventListeners[index]) {
                this._eventListeners[index](eventName, await this.getLocation());
            }
        }
    }
    async getLocationInternalAsync(update) {
        if (this._geoLocationApi) {
            // If the cached location has not yet been fetched or needs to be updated, get it from the host
            if (update || this._geoLocation == undefined) {
                const [latitude, longitude, accuracy, positionSource, timestamp] = await Promise.all([
                    this._geoLocationApi.latitude,
                    this._geoLocationApi.longitude,
                    this._geoLocationApi.accuracy,
                    this._geoLocationApi.positionSource,
                    this._geoLocationApi.timestamp,
                ]);
                this._geoLocation = new WidgetGeolocation(latitude, longitude, accuracy, positionSource, timestamp);
            }
            return this._geoLocation;
        }
        throw new Error("You must call initialize() before using this object");
    }
}
